module.exports = __webpack_public_path__ + "static/media/ethiopia.9289c4fd.png";